package com.rainbowclubs.rainbow.data.requests

import kotlinx.serialization.Serializable

@Serializable
data class SignEventAttendeeRequest(
    val adminUserId: String,
    val attendeeUserId: String,
)
